<template>
  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="1">同步中</a-select-option>
            <a-select-option :value="2">同步成功</a-select-option>
            <a-select-option :value="3">同步失败</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.hid"
              allowClear
              placeholder="房间ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.storeId"
              allowClear
              placeholder="门店ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.sam"
              allowClear
              placeholder="苏安码"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.sn"
              allowClear
              placeholder="设备SN"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.order_no"
              :loading="searchLoading"
              placeholder="订单号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="房间|门店"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'status'">
          <span v-if="record.status == 1" class="f-c-red">同步中</span>
          <span v-else-if="record.status == 2" class="f-c-green">同步成功</span>
          <span v-else class="f-c-red">同步失败</span>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />
    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {reportStatJsCheckIn,} from "@/api/api";
import {AppstoreOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";

export default {
  components: {
    OrderDetails,
    AppstoreOutlined,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: [],
        hid: '',
        order_no: '',
        storeId: '',
        sam: '',
        sn: '',
        keyword: "",
        start: 0,
        limit: 20,
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.keyword = "";
        search.searchForm.hid = "";
        search.searchForm.status = [];
        search.searchForm.sam = "";
        search.searchForm.sn = "";
        search.searchForm.order_no = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "记录ID",
          dataIndex: "id",
          key: "id",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "SN",
          dataIndex: "sn",
          key: "sn",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "房间ID",
          dataIndex: "hid",
          key: "hid",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "房间名称",
          dataIndex: "hname",
          key: "hname",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "门店ID",
          dataIndex: "storeId",
          key: "storeId",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
          width: 100,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "苏安码",
          dataIndex: "FYTYBM",
          key: "FYTYBM",
          width: 150,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "上报时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "上报备注",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "入住登记编号",
          dataIndex: "RZDJBH",
          key: "RZDJBH",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "门锁登记编号",
          dataIndex: "MSDJBH",
          key: "MSDJBH",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "房源登记编号",
          dataIndex: "FYDJBH",
          key: "FYDJBH",
          width: 100,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "订单来源平台",
          dataIndex: "DDLYPTTYBM",
          key: "DDLYPTTYBM",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "订单平台编号",
          dataIndex: "DDPTBH",
          key: "DDPTBH",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "拟入住人数量",
          dataIndex: "NRZRSL",
          key: "NRZRSL",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "入住时间",
          dataIndex: "NRZSJ",
          key: "NRZSJ",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "退房时间",
          dataIndex: "NTFSJ",
          key: "NTFSJ",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "实际入住时间",
          dataIndex: "SJRZSJ",
          key: "SJRZSJ",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "实际退房时间",
          dataIndex: "SJTFSJ",
          key: "SJTFSJ",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "登记日期",
          dataIndex: "DJSJ",
          key: "DJSJ",
          width: 120,
          isShow: true,
          align: "center",
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        reportStatJsCheckIn(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: getColumns(),
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });


    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 15;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 15;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
